import React from "react";
import { Parallax } from "react-scroll-parallax";
import { motion, useAnimation } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ChairmanMessage from "./ChairmanMessage";
    if (typeof window !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
      }
      
const AboutPage = () => {
        const sectionRef = useRef(null);
        const headingRef = useRef(null);
        const textRef = useRef(null);
        const imageRef = useRef(null);
      
        useEffect(() => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 80%',
              end: 'bottom 90%',
              scrub: true,
            },
          });
      
          tl.fromTo(
            headingRef.current,
            { opacity: 0, y: -50 },
            { opacity: 1, y: 0, duration: 1 }
          ).fromTo(
            textRef.current,
            {  y: -100 },
            {  y: 0, duration: 1 },
            '-=0.5'
          ).fromTo(
            imageRef.current,
            {  scale: 0.8, y:100 },
            {  scale: 1, y:0, duration: 1 },
            '-=1'
          );
        }, []);
      


        const stats = [
          { target: 8, label: "Years of Experience" },
          { target: 500, label: "Happy Clients" },
          { target: 150, label: "Total Projects" },
          { target: 40, label: "Ongoing Projects" },
          { target: 90, label: "Completed Projects" },
          { target: 20, label: "Upcoming Projects" },
        ];


        const Counter = ({ target }) => {
          const controls = useAnimation();
          const [value, setValue] = useState(0);
      
          useEffect(() => {
            controls.start({
              value: target,
              transition: { duration: 2, ease: "easeOut" },
            });
          }, [target]);
      
          return (
            <motion.span
              animate={controls}
              initial={{ value: 0 }}
              onUpdate={(latest) => setValue(latest.value.toFixed(0))}
              className="text-4xl font-bold text-yellow-700"
            >
              {value}
            </motion.span>
          );
        };
  return (
    <div className="relative">
      {/* Parallax Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('../about3.jpg')",
          height: "100vh",
        }}
      >
        {/* Overlay to darken background */}
        <div className="absolute inset-0 bg-white "></div>
      </div>

      {/* Main Content */}
      <div className="relative  text-white">
        
        

        {/* About Section */}
        <div ref={sectionRef} className="bg-white max-w-7xl mx-auto bg-opacity-90 py-20 px-6">
      <div className="container mx-auto flex flex-col md:flex-row items-center gap-10">
        <div className="md:w-1/2" ref={imageRef}>
          <img
            src="./about.jpg" // Replace with actual image path
            alt="Real Estate"
            
            className="rounded-lg shadow-lg w-full h-auto"
          />
        </div>
        <div className="md:w-1/2 text-gray-300 text-justify" ref={textRef}>
          <h2 ref={headingRef} className="text-3xl md:text-4xl font-semibold font-serif text-yellow-600 mb-6 text-center md:text-left">
            SpanBucks
          </h2>
          <p className=" text-gray-500">
            Your Trusted Partner for Seamless Real Estate Solutions, All in One Place.
          </p>
          <p className="mt-4 text-gray-400">
            At SpanBucks Developers and Builders Private Limited, we believe real estate is more than just buying and selling properties—it’s about building a future. Established on March 04, 2024, our mission is to revolutionize the real estate industry by integrating innovation, technology, transparency and market intelligence to create customer-centric solutions.
          </p>
          <p className="mt-4 text-gray-400">
           As a next-generation real estate company, we are driven by passion, expertise, and a commitment to excellence. Whether you're purchasing your dream home, making smart investments, renting or selling for maximum value, our expert team ensures a faster, smarter, and seamless experience. With a foundation built on trust, strategic investments, and long-term prosperity, SpanBucks is here to guide you through every step of your real estate journey with integrity and innovation.
          </p>
          <p className="mt-4 text-gray-400">
          We invite homebuyers, businesses, and investors to embark on this exciting journey with us—let’s shape the future of real estate together!
          </p>
        </div>
      </div>
    </div>
    <ChairmanMessage/>

    <div className=" py-16">
      <div className="max-w-4xl mx-auto grid grid-cols-2 sm:grid-cols-3 gap-6 text-center">
        {stats.map((stat, index) => (
          <div key={index} className="relative">
            <h2 className="text-5xl font-semibold text-yellow-700">
              <Counter target={stat.target} /> +
            </h2>
            <p className="mt-2 text-gray-600">{stat.label}</p>
            {index !== stats.length - 1 && (
              <span className="hidden sm:block absolute right-0 top-1/2 transform -translate-y-1/2 h-12 w-px bg-gray-300"></span>
            )}
          </div>
        ))}
      </div>
    </div>

        {/* Why Choose Us Section */}
        <div className="bg-black max-w-7xl mx-auto">
  {/* <div className="container mx-auto px-6">
    <Parallax translateY={[10, 80]}>
      <motion.h3
        className="text-3xl font-serif md:text-4xl font-semibold text-center text-yellow-600 mb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Why Choose Us?
      </motion.h3>
    </Parallax>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {/* First Card 
      <div className="bg-gray-950 p-8 overflow-hidden rounded shadow-lg text-white border-gray-800 text-center transition duration-700 hover:scale-110 border-2 hover:border-yellow-600">
        <Parallax translateY={[-40, 40]}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="text-lg"
          >
            <h4 className="text-xl font-semibold mb-4">Trustworthy Guidance</h4>
            <p className="text-gray-500 text-justify">
            We build lasting relationships with transparency and reliability.
            </p>
          </motion.div>
        </Parallax>
      </div>

      {/* Second Card 
      <div className="bg-gray-950 p-8 overflow-hidden rounded shadow-lg text-white border-gray-800 text-center transition duration-700 hover:scale-110 border-2 hover:border-yellow-600">
        <Parallax translateY={[-40, 40]}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.7 }}
            className="text-lg"
          >
            <h4 className="text-xl font-semibold mb-4">Smart Investments</h4>
            <p className="text-gray-500 text-justify">
                Backed by market research and industry expertise, we identify high-potential real estate opportunities.
            </p>
          </motion.div>
        </Parallax>
      </div>

      {/* Third Card 
      <div className="bg-gray-950 p-8 overflow-hidden rounded shadow-lg text-white border-gray-800 text-center transition duration-700 hover:scale-110 border-2 hover:border-yellow-600">
        <Parallax translateY={[-40, 40]}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.9 }}
            className="text-lg"
          >
            <h4 className="text-xl font-semibold mb-4">Sustainable Prosperity</h4>
            <p className="text-gray-500 text-justify">
                Our goal is not just short-term gains but long-term financial success for our clients.
            </p>
          </motion.div>
        </Parallax>
      </div>
    </div>
  </div> */}
</div>


        {/* Company Values Section */}
        <div className="bg-white pb-20">
   <div className="container max-w-7xl mx-auto px-6">
    {/* <motion.h3
      className="text-3xl md:text-4xl font-semibold text-center text-yellow-600 mb-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      Our Core Values
    </motion.h3> */}

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

      <div className="bg-white p-8 rounded shadow-lg text-white border-gray-300 text-center transition duration-700 hover:scale-110 border-2 overflow-hidden hover:border-yellow-600">
      <Parallax translateY={[-40, 40]}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="text-lg"
        >
          <h3 className="text-3xl text-yellow-600 font-semibold mb-4">Our Mission </h3>
          <p className="text-gray-500 text-justify">
            At SpanBucks, our mission is to create wealth and opportunities through real estate by fostering trust, guiding smart investments, and ensuring our clients prosper. We are committed to delivering transparent, ethical, and result-driven real estate solutions that empower individuals and businesses to achieve long-term financial success.
          </p>
        </motion.div>
        </Parallax>
      </div>


      <div className="bg-white p-8 rounded shadow-lg text-white border-gray-300 text-center transition duration-700 hover:scale-110 overflow-hidden border-2 hover:border-yellow-600">
      <Parallax translateY={[-40, 40]}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
          className="text-lg"
        >
          <h3 className="text-3xl text-yellow-600 font-semibold mb-4">Our Vision</h3>
          <p className="text-gray-500 text-justify">
          To be the most trusted real estate partner, known for helping clients invest wisely and prosper abundantly. We envision a future where real estate is accessible, secure, and a key driver of financial growth for all. Through innovation, expertise, and unwavering trust, we aim to shape thriving communities and transform real estate aspirations into realities.
          </p>
        </motion.div>
        </Parallax>
      </div>

     
      
    </div>
  </div> 
</div>


        {/* Final CTA Section */}
        <div className="bg-yellow-700 max-w-full mx-auto py-20">
  <div className="container mx-auto px-6 text-center">
    <motion.h3
      className="text-3xl md:text-4xl font-semibold text-black mb-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      Ready to Make Smart Investments?
    </motion.h3>
    <p className="text-lg text-gray-300 mb-6">
      Partner with SpanBucks to secure your future with premium real estate opportunities. We help you find the perfect property tailored to your needs.
    </p>
    <Link to="/Contact" className="bg-red-600 border-2 border-yellow-700 active:scale-90 hover:scale-110 text-white py-3 px-8 rounded-full hover:bg-black transition duration-700">
      Get in Touch
    </Link>
  </div>
</div>

      </div>
    </div>
  );
};

export default AboutPage;








// import React from "react";
// import { Parallax } from "react-scroll-parallax";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import aboutImage from "../about3.jpg";
// import expertiseImage from "../expertise.jpg";
// import reachImage from "../reach.jpg";
// import customerImage from "../customer.jpg";
// import innovationImage from "../innovation.jpg";
// import successImage from "../success.jpg";
// import qualityImage from "../quality.jpg";

// const AboutPage = () => {
//   return (
//     <div className="relative">
//       {/* Parallax Background Image */}
//       <div
//         className="absolute inset-0 bg-cover bg-center"
//         style={{ backgroundImage: `url(${aboutImage})`, height: "100vh" }}
//       >
//         <div className="absolute inset-0 bg-black bg-opacity-50"></div>
//       </div>

//       {/* Main Content */}
//       <div className="relative text-white">
//         <div className="bg-black max-w-7xl mx-auto bg-opacity-90 py-20">
//           <div className="container mx-auto px-6">
//             <Parallax translateY={[-50, 50]}>
//               <motion.h2
//                 className="text-3xl md:text-4xl font-semibold text-center text-red-600 mb-8"
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 1 }}
//               >
//                 About TNR Technologies
//               </motion.h2>
//             </Parallax>
//             <div className="flex flex-col md:flex-row items-center gap-8">
//               <Parallax translateY={[50, -50]}>
//                 <img src={aboutImage} alt="About Us" className="rounded-lg shadow-lg w-full md:w-1/2" />
//               </Parallax>
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 1, delay: 0.5 }}
//                 className="text-lg text-gray-300 text-justify leading-relaxed w-full md:w-1/2"
//               >
//                 <p>
//                   TNR Technologies is shaping the future of technology by empowering businesses with innovative solutions...
//                 </p>
//               </motion.div>
//             </div>
//           </div>
//         </div>

//         {/* Why Choose Us Section */}
//         <div className="bg-black max-w-7xl mx-auto py-20">
//           <div className="container mx-auto px-6 text-center">
//             <Parallax translateY={[-50, 50]}>
//               <motion.h3
//                 className="text-3xl md:text-4xl font-semibold text-red-600 mb-8"
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 1 }}
//               >
//                 Why Choose TNR Technologies?
//               </motion.h3>
//             </Parallax>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               {[{ title: "Expertise", img: expertiseImage }, { title: "Reach", img: reachImage }, { title: "Customer Focus", img: customerImage }].map((item, index) => (
//                 <Parallax key={index} translateY={[-40, 40]}>
//                   <motion.div
//                     className="bg-gray-950 p-8 rounded shadow-lg text-white border-2 border-gray-800 hover:border-red-600 transition duration-700 hover:scale-110"
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ duration: 1, delay: 0.5 + index * 0.2 }}
//                   >
//                     <img src={item.img} alt={item.title} className="rounded mb-4" />
//                     <h4 className="text-xl font-semibold mb-4">{item.title}</h4>
//                   </motion.div>
//                 </Parallax>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Core Values Section */}
//         <div className="bg-black py-20">
//           <div className="container max-w-7xl mx-auto px-6">
//             <motion.h3
//               className="text-3xl md:text-4xl font-semibold text-center text-red-600 mb-8"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 1 }}
//             >
//               Our Core Values
//             </motion.h3>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               {[{ title: "Innovation", img: innovationImage }, { title: "Customer Success", img: successImage }, { title: "Quality", img: qualityImage }].map((item, index) => (
//                 <motion.div
//                   key={index}
//                   className="bg-gray-950 p-8 rounded shadow-lg text-white border-2 border-gray-800 hover:border-red-600 transition duration-700 hover:scale-110"
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ duration: 1, delay: 0.5 + index * 0.2 }}
//                 >
//                   <img src={item.img} alt={item.title} className="rounded mb-4" />
//                   <h4 className="text-xl font-semibold mb-4">{item.title}</h4>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Call To Action Section */}
//         <div className="bg-black max-w-7xl mx-auto py-20 text-center">
//           <motion.h3
//             className="text-3xl md:text-4xl font-semibold text-red-600 mb-8"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 1 }}
//           >
//             Ready to Embrace the Future?
//           </motion.h3>
//           <p className="text-lg text-gray-300 mb-6">
//             Partner with TNR Technologies to unlock limitless possibilities...
//           </p>
//           <Link to="/contact" className="bg-red-600 border-2 border-red-600 hover:scale-110 text-white py-3 px-8 rounded-full hover:bg-transparent transition duration-300">
//             Get in Touch
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutPage;
